export enum UserRole {
  Admin,
  Salesman,
  Client
}
